import { FormattedMessage, FormattedDate } from 'react-intl';
import messages from './DaysMessage.messages';

export const DaysMessage = (props) => {
    const { className, approvalStatusTimeOut } = props;

    return (
        <span className={className}>
            <FormattedMessage
                {...messages.creditUtilisationLimitMessage}
                values={{
                    date: (
                        <FormattedDate
                            value={new Date(approvalStatusTimeOut)}
                            day="2-digit"
                            month="long"
                            year="numeric"
                        />
                    )
                }}
            />
        </span>
    );
};
